import React from 'react';

import AddFolderComponent from 'Drive/AddFolderComponent';

const NewFolder = ({ close }) => {
  return <AddFolderComponent type="menuItem" close={close} />;
};

export default NewFolder;
